import React from 'react';
import { PageLayout, LoginContentTemplate, NotLoginContentTemplate } from '@/features/common/components/layout';
import WinkFreeStudy from '@/features/wink/winkexperience/WinkFreeStudy';
import WinkFreeStudyNotLogin from '@/features/wink/winkexperience/WinkFreeStudyNotLogin';

const FreeStudyPage = ({ history }) => {
    return (
        <PageLayout>
            <LoginContentTemplate history={history}>
                <WinkFreeStudy history={history} />
            </LoginContentTemplate>
            <NotLoginContentTemplate history={history}>
                <WinkFreeStudyNotLogin history={history} />
            </NotLoginContentTemplate>
        </PageLayout>
    );
};

export default FreeStudyPage;
